import React, { forwardRef, ReactNode } from 'react';
import styles from './input.module.css';
import classNames from 'classnames';

// Extend the props to include all input attributes
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  bigger?: boolean;
  withIcon?: ReactNode;
  iconPosition?: 'left' | 'right';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      bigger = false,
      withIcon = false,
      iconPosition = 'right',
      ...props
    },
    ref
  ) => {
    const input = (
      <input
        className={classNames(
          styles.input,
          {
            [styles['input--bigger']]: bigger,
            [styles['input--icon-left']]: withIcon && iconPosition === 'left',
            [styles['input--icon-right']]: withIcon && iconPosition === 'right',
          },
          className
        )}
        {...props} // Spread all props, allowing standard input attributes
        ref={ref}
      />
    );

    if (withIcon) {
      return (
        <div className={styles['input-wrapper']}>
          {input}
          <div
            className={classNames(styles['input-icon'], {
              [styles['input-icon--left']]: iconPosition === 'left',
              [styles['input-icon--right']]: iconPosition === 'right',
            })}
          >
            {withIcon}
          </div>
        </div>
      );
    }

    return input;
  }
);
